import React, { useState } from 'react'

import DoubleBounceSpinner from '~/components/double-bounce-spinner'
import SaveCardOnFile from '~/components/save-card-on-file'
import { FREEDOMPAY_HPC_URL } from '~/config'
import { i18n } from '~/i18n'

import { StyledForm, StyledIframe } from './freedom-pay-hpc.styles'

import type { LegacyRef } from 'react'
import type { Cart } from '~/types'

type Props = {
  sessionKey: string
  frameHeight: number
  iframeRef: LegacyRef<HTMLIFrameElement>
  formState: {
    nameOnCard: string
  }
  onChange: (field: string, value: string) => void
  errors: Record<string, any>
  cart: Cart
  onChangeSaveCardOnFile?: () => void
  saveCardOnFile: boolean
}

export default function FreedomPayHpc({
  sessionKey,
  frameHeight,
  iframeRef,
  formState,
  onChange,
  errors,
  cart,
  onChangeSaveCardOnFile,
  saveCardOnFile,
}: Props) {
  const [loading, setLoading] = useState(true)

  return (
    <>
      {loading && <DoubleBounceSpinner />}
      {!loading && (
        <StyledForm
          object={formState}
          errors={errors}
          fields={{
            nameOnCard: {
              type: 'text',
              label: i18n.t('components.credit_card_form.name_label'),
              placeholder: i18n.t(
                'components.credit_card_form.name_placeholder',
              ),
            },
          }}
          onChange={onChange}
        />
      )}
      <StyledIframe
        ref={iframeRef}
        title="freedompay-hpc-form"
        $frameHeight={frameHeight}
        scrolling="no"
        src={`${FREEDOMPAY_HPC_URL}?sessionKey=${sessionKey}`}
        onLoad={() => setLoading(false)}
      />
      {onChangeSaveCardOnFile && !loading && (
        <SaveCardOnFile
          cart={cart}
          onChange={onChangeSaveCardOnFile}
          save={saveCardOnFile}
        />
      )}
    </>
  )
}
